module.exports = __webpack_public_path__ + "static/media/customer-service.4405345d.svg";